import {EligibilityItemsDetails, ProviderClaimEligibility, SupportClaimEligibility} from '@enter/core';
import _ from 'lodash';
import React from 'react';
import * as S from './eligibility-detail.styles';

interface IEligibilityDetailProps {
    eligibility: ProviderClaimEligibility|SupportClaimEligibility;
}

export const EligibilityDetail: React.FunctionComponent<IEligibilityDetailProps> = (
    props: IEligibilityDetailProps,
): React.ReactElement => {
    const { eligibility } = props;

    const validationErrors = [];

    if(eligibility.validations) {
        for(const validation of eligibility.validations) {
            validationErrors.push(<S.ExpandTR>
                <S.ExpandTH>Validation Error</S.ExpandTH>
                <S.ExpandTD>Reason: {validation.rejectReasonType}, Suggested Action: {validation.followupActionType}</S.ExpandTD>
            </S.ExpandTR>);
        }
    }

    const renderedEligibility = (validationErrors.length === 0 && (!eligibility.items || eligibility.items.length === 0) && eligibility.dependents && eligibility.dependents.length > 0 && eligibility.dependents[0].items && eligibility.dependents[0].items.length > 0) ? eligibility.dependents[0] : eligibility;

    const name = _.compact([renderedEligibility.first, renderedEligibility.last]).join(' ');

    return (
        <S.ExpandCol>
            <S.ExpandTable>
                <S.ExpandTBody>
                    {!!name && (
                        <S.ExpandTR>
                            <S.ExpandTH>Insured Name</S.ExpandTH>
                            <S.ExpandTD>{name}</S.ExpandTD>
                        </S.ExpandTR>
                    )}
                    {!!renderedEligibility.planId && (
                        <S.ExpandTR>
                            <S.ExpandTH>Plan ID</S.ExpandTH>
                            <S.ExpandTD>{renderedEligibility.planId}</S.ExpandTD>
                        </S.ExpandTR>
                    )}
                    {!!renderedEligibility.planDescription && (
                        <S.ExpandTR>
                            <S.ExpandTH>Plan Description</S.ExpandTH>
                            <S.ExpandTD>{renderedEligibility.planDescription}</S.ExpandTD>
                        </S.ExpandTR>
                    )}
                    {!!renderedEligibility.groupId && (
                        <S.ExpandTR>
                            <S.ExpandTH>Group ID</S.ExpandTH>
                            <S.ExpandTD>{renderedEligibility.groupId}</S.ExpandTD>
                        </S.ExpandTR>
                    )}
                    {!!renderedEligibility.groupDescription && (
                        <S.ExpandTR>
                            <S.ExpandTH>Group Description</S.ExpandTH>
                            <S.ExpandTD>{renderedEligibility.groupDescription}</S.ExpandTD>
                        </S.ExpandTR>
                    )}
                    {!!renderedEligibility.otherQualifierId && (
                        <S.ExpandTR>
                            <S.ExpandTH>Other Qualifier ID</S.ExpandTH>
                            <S.ExpandTD>{renderedEligibility.otherQualifierId}</S.ExpandTD>
                        </S.ExpandTR>
                    )}
                    {!!renderedEligibility.otherId && (
                        <S.ExpandTR>
                            <S.ExpandTH>Other ID</S.ExpandTH>
                            <S.ExpandTD>{renderedEligibility.otherId}</S.ExpandTD>
                        </S.ExpandTR>
                    )}
                    {!!renderedEligibility.otherDescription && (
                        <S.ExpandTR>
                            <S.ExpandTH>Other Description</S.ExpandTH>
                            <S.ExpandTD>{renderedEligibility.otherDescription}</S.ExpandTD>
                        </S.ExpandTR>
                    )}
                    {!!renderedEligibility.planStartDate && (
                        <S.ExpandTR>
                            <S.ExpandTH>Plan Start Date</S.ExpandTH>
                            <S.ExpandTD>{renderedEligibility.planStartDate}</S.ExpandTD>
                        </S.ExpandTR>
                    )}
                    {!!renderedEligibility.planEndDate && (
                        <S.ExpandTR>
                            <S.ExpandTH>Plan End Date</S.ExpandTH>
                            <S.ExpandTD>{renderedEligibility.planEndDate}</S.ExpandTD>
                        </S.ExpandTR>
                    )}
                    {validationErrors.length > 0 && (validationErrors)}
                </S.ExpandTBody>
            </S.ExpandTable>
            {renderedEligibility.items && <EligibilityItemsDetails items={renderedEligibility.items} />}
        </S.ExpandCol>
    );
};
